export const languageExamples: { [key: string]: string } = {
	// Cartesia supported
	English: 'Hello, how may I help you?',
	German: 'Hallo, wie kann ich Ihnen helfen?',
	Portuguese: 'Olá, como posso ajudá-lo?',
	Mandarin: '你好，我可以帮助你吗？',
	Japanese: 'こんにちは、どのようなお手伝いができますか？',
	French: 'Bonjour, comment puis-je vous aider ?',
	Spanish: 'Hola, ¿en qué puedo ayudarte?',
	Hindi: 'नमस्ते, मैं आपकी कैसे मदद कर सकता हूँ?',
	Italian: 'Ciao, come posso aiutarti?',
	Korean: '안녕하세요, 어떻게 도와 드릴까요?',
	Dutch: 'Hallo, hoe kan ik je helpen?',
	Polish: 'Cześć, jak mogę ci pomóc?',
	Russian: 'Привет, чем я могу помочь вам?',
	Swedish: 'Hej, hur kan jag hjälpa dig?',
	Turkish: 'Merhaba, size nasıl yardımcı olabilirim?',

	// Non-cartesia supported
	'Swiss German': 'Hallo, wie kann ich Ihnen helfen?',
	Romanian: 'Bună, cum te pot ajuta?',
	Vietnamese: 'Xin chào, tôi có thể giúp gì cho bạn?',
	Danish: 'Hej, hvordan kan jeg hjælpe dig?',
	Catalan: 'Hola, en què puc ajudar-vos?',
	Slovak: 'Ahoj, ako vám môžem pomôcť?',
	Ukrainian: 'Привіт, чим я можу допомогти?',
	Thai: 'สวัสดีค่ะ/ครับ ฉันสามารถช่วยอะไรคุณได้บ้าง?',
	Norwegian: 'Hei, hvordan kan jeg hjelpe deg?',
	Lithuanian: 'Labas, kuo galiu padėti?',
	Latvian: 'Sveiki, kā es varu jums palīdzēt?',
	Malay: 'Hello, bagaimana saya boleh membantu anda?',
	Indonesian: 'Halo, bagaimana saya bisa membantu Anda?',
	Hungarian: 'Szia, hogyan segíthetek?',
	Greek: 'Γεια σας, πώς μπορώ να σας βοηθήσω;',
	Flemish: 'Hallo, hoe kan ik u helpen?',
	Finnish: 'Hei, kuinka voin auttaa sinua?',
	Estonian: 'Tere, kuidas ma saan aidata?',
	Czech: 'Ahoj, jak vám mohu pomoci?',
	Bulgarian: 'Здравейте, как мога да ви помогна?',
	Arabic: 'مرحبا، كيف يمكنني مساعدتك؟',
	Armenian: 'Բարև, ինչպես կարող եմ օգնել ձեզ?',
	'Haitian Creole': 'Bonjou, kijan mwen ka ede ou?',
};
